import { useAuth } from '../../contexts/AuthContext';
import { StaffRewardProgress } from '../../components/rewards/StaffRewardProgress';
import { ResidentRewards } from '../../components/rewards/ResidentRewards';

export default function ResidentOperationRecord(){
  const {user}=useAuth();
  return ['agent','site_agent','crew_leader','supervisor','manager','regional_manager'].includes(user?.role)
    ? <StaffRewardProgress prefix="operation-record-progress"/>
    : <ResidentRewards prefix="operation-record-rewards"/>;
}